import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";

import { pageQuery } from "@/lib/queries";
import { PageHero, Section, EmptyState } from "@/components/site/bits";

export const Route = createFileRoute("/privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade | Professor Rurdiney — 40123" },
      {
        name: "description",
        content: "Política de privacidade e tratamento de dados pessoais (LGPD) do site do Professor Rurdiney.",
      },
      { property: "og:title", content: "Política de Privacidade | Professor Rurdiney — 40123" },
      {
        property: "og:description",
        content: "Saiba como tratamos seus dados pessoais em conformidade com a LGPD.",
      },
    ],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQuery("privacidade")),
  component: PrivacidadePage,
});

function PrivacidadePage() {
  const { data: page } = useSuspenseQuery(pageQuery("privacidade"));
  const blocks: Array<{ type: string; level?: number; text: string }> =
    (page?.content as any)?.blocks ?? [];

  return (
    <>
      <PageHero
        eyebrow="LGPD"
        title={page?.title || "Política de Privacidade"}
        description={page?.subtitle || "Como coletamos, usamos e protegemos seus dados pessoais."}
      />

      <Section>
        <div className="prose-campaign mx-auto max-w-3xl">
          {blocks.length === 0 && <EmptyState message="Conteúdo em breve." />}
          {blocks.map((b, i) =>
            b.type === "heading" ? (
              <h2 key={i} className="mt-8 text-2xl md:text-3xl text-balance-title first:mt-0">
                {b.text}
              </h2>
            ) : (
              <p key={i} className="mt-4 text-base leading-relaxed text-muted-foreground">
                {b.text}
              </p>
            ),
          )}
        </div>
      </Section>
    </>
  );
}
